import { apiAxios } from "./apiConfig";

export interface Updater {
  id?: string;
  name?: string;
}

export interface UserRequest {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  status: "pending" | "accept" | "reject";
  statusUpdatedDate: string | null;
  rejectReason: string | null;
  updater: Updater | null;
  createdAt: string | null;
}

export interface UserRequestListResponse {
  status: boolean;
  data: UserRequest[];
}

export const getUserRequestList =
  async (): Promise<UserRequestListResponse> => {
    const response =
      await apiAxios.get<UserRequestListResponse>("/user/request/list");
    return response.data;
  };

export const updateUserRequestStatus = async (
  userId: string,
  payload: {
    status: "accept" | "reject" | "delete" | "activate";
    rejectReason?: string;
  },
) => {
  const response = await apiAxios.put(`/admin/user/${userId}/status`, payload);

  return response.data;
};
